import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { getHandlingUnitTypeInfo } from "@/Data/getHandlingUnitTypeInfo";

export function formatHandlingUnitTypeWithQuantity(
  numberHandlingUnits: number,
  handlingUnitType: HandlingUnitType,
) {
  const item = getHandlingUnitTypeInfo(handlingUnitType);

  if (numberHandlingUnits > 1) {
    return `${numberHandlingUnits} x ${item.plural}`;
  } else {
    return `${numberHandlingUnits} x ${item.singular}`;
  }
}
